<template>
  <div class="floating-button">
    <router-link to="/bolsa-trabajo">
        <button class="boton-flotante d-none d-md-block">
            ¡Únete a nuestro equipo de trabajo!
            <i class="fas fa-briefcase ml-2"></i>
        </button>
        <button class="d-md-none">
          <i class="fas fa-briefcase"></i>
        </button>
    </router-link>
</div>
</template>

<script>
export default {

}
</script>

<style scoped>
.floating-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  margin-bottom: 70px;
}

.floating-button button {
  background-image: linear-gradient(80deg, rgb(18, 51, 223), rgb(74, 132, 215));
  color: #fff;
  border: none;
  padding: 12px 24px;
  border-radius: 50px;
  cursor: pointer;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease-in-out;
}

.floating-button button:hover {
  transform: translateY(-4px);
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);
}


</style>